"use client";

import { CommentsSection as CommentsType } from "@/types/home";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Quote } from "lucide-react";

interface CommentsSectionProps {
      data: CommentsType;
}

export default function CommentsSection({ data }: CommentsSectionProps) {
      if (!data) return null;

      return (
            <section className="py-16 bg-white overflow-hidden relative">
                  <div className="container mx-auto px-4 md:px-8 relative z-10">
                        <div className="text-left max-w-3xl mb-10">
                              {data.badge && (
                                    <span className="inline-block py-1 px-3 rounded-full bg-[#A68F72]/10 text-[#A68F72] text-xs font-semibold tracking-wider uppercase mb-3 border border-[#A68F72]/20">
                                          {data.badge}
                                    </span>
                              )}
                              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
                                    {data.title}
                              </h2>
                        </div>

                        <Swiper
                              modules={[Pagination, Autoplay]}
                              spaceBetween={24}
                              slidesPerView={1}
                              pagination={{
                                    clickable: true,
                                    dynamicBullets: true,
                              }}
                              autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                              }}
                              breakpoints={{
                                    768: { slidesPerView: 2 },
                                    1024: { slidesPerView: 3 },
                              }}
                              className="pb-12 overflow-visible! [&_.swiper-pagination-bullet]:bg-gray-300 [&_.swiper-pagination-bullet]:opacity-100 [&_.swiper-pagination-bullet-active]:bg-[#A68F72]!"
                        >
                              {data.commentsItem.map((item) => (
                                    <SwiperSlide key={item.id} className="h-auto">
                                          <div className="h-full bg-[#faf9f6] p-6 rounded-3xl relative border border-[#ece9e3] flex flex-col hover:border-[#A68F72]/30 transition-colors duration-300 group">
                                                <div className="text-[#A68F72]/20 mb-4 group-hover:text-[#A68F72]/40 transition-colors">
                                                      <Quote size={32} className="fill-current" />
                                                </div>
                                                <p className="text-gray-600 text-base leading-relaxed italic mb-5 grow">
                                                      "{item.comment}"
                                                </p>
                                                <div className="mt-auto pt-4 border-t border-[#A68F72]/10 flex flex-col">
                                                      <p className="font-bold text-gray-900 text-base">
                                                            {item.name}
                                                      </p>
                                                      <p className="text-xs text-[#A68F72] font-medium">
                                                            Danışan
                                                      </p>
                                                </div>
                                          </div>
                                    </SwiperSlide>
                              ))}
                        </Swiper>
                  </div>
            </section>
      );
}